import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography, Button, Space, Table } from "antd";
import { BarChartOutlined, FileExcelOutlined } from "@ant-design/icons";

import "./css/dashboard.css";

import * as xlsx from "xlsx";

const { Title } = Typography;

const cardStyle = {
  height: 420,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const cardStyle2 = {
  height: 200,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};
const Dashboard7_2 = () => {
  let xURL = "";

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const columns7_2_11 = [
    {
      title: "ปีการศึกษา",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "ปริญญาโท",
      key: "c2",
      align: "center",
      children: [
        {
          title: "รับเข้า",
          dataIndex: "c2_1",
          key: "c2_1",
          align: "center"
        },
        {
          title: "ลาออก",
          dataIndex: "c2_2",
          key: "c2_2",
          align: "center"
        },
        {
          title: "คงเหลือ",
          dataIndex: "c2_3",
          key: "c2_3",
          align: "center"
        }
      ]
    },
    {
      title: "ปริญญาเอก",
      key: "c3",
      align: "center",
      children: [
        {
          title: "รับเข้า",
          dataIndex: "c3_1",
          key: "c3_1",
          align: "center"
        },
        {
          title: "ลาออก",
          dataIndex: "c3_2",
          key: "c3_2",
          align: "center"
        },
        {
          title: "คงเหลือ",
          dataIndex: "c3_3",
          key: "c3_3",
          align: "center"
        }
      ]
    },
    {
      title: "รวมรับเข้า",
      dataIndex: "c4",
      key: "c4",
      align: "center"
    },
    {
      title: "รวมคงเหลือ",
      dataIndex: "c5",
      key: "c5",
      align: "center"
    }
  ];

  const data7_2_11 = [
    {
      key: "1",
      c1: "2565",
      c2_1: "9",
      c2_2: "0",
      c2_3: "9",
      c3_1: "12",
      c3_2: "0",
      c3_3: "12",
      c4: "20",
      c5: "20"
    },
    {
      key: "2",
      c1: "2566",
      c2_1: "9",
      c2_2: "3",
      c2_3: "6",
      c3_1: "10",
      c3_2: "1",
      c3_3: "9",
      c4: "19",
      c5: "15"
    },
    {
      key: "3",
      c1: "2567",
      c2_1: "9",
      c2_2: "0",
      c2_3: "9",
      c3_1: "7",
      c3_2: "1",
      c3_3: "6",
      c4: "16",
      c5: "15"
    },
    {
      key: "4",
      c1: "2568",
      c2_1: "6",
      c2_2: "1",
      c2_3: "5",
      c3_1: "15",
      c3_2: "0",
      c3_3: "15",
      c4: "21",
      c5: "20"
    },
    {
      key: "5",
      c1: "รวม",
      c2_1: "",
      c2_2: "",
      c2_3: "",
      c3_1: "",
      c3_2: "",
      c3_3: "",
      c4: "76",
      c5: "70"
    }
  ];

  const dataEx7_2_11 = [
    {
      c1: "2565",
      c2_1: "9",
      c2_2: "0",
      c2_3: "9",
      c3_1: "12",
      c3_2: "0",
      c3_3: "12",
      c4: "20",
      c5: "20"
    },
    {
      c1: "2566",
      c2_1: "9",
      c2_2: "3",
      c2_3: "6",
      c3_1: "10",
      c3_2: "1",
      c3_3: "9",
      c4: "19",
      c5: "15"
    },
    {
      c1: "2567",
      c2_1: "9",
      c2_2: "0",
      c2_3: "9",
      c3_1: "7",
      c3_2: "1",
      c3_3: "6",
      c4: "16",
      c5: "15"
    },
    {
      c1: "2568",
      c2_1: "6",
      c2_2: "1",
      c2_3: "5",
      c3_1: "15",
      c3_2: "0",
      c3_3: "15",
      c4: "21",
      c5: "20"
    },
    {
      c1: "รวม",
      c2_1: "",
      c2_2: "",
      c2_3: "",
      c3_1: "",
      c3_2: "",
      c3_3: "",
      c4: "76",
      c5: "70"
    }
  ];

  const columns7_2_16 = [
    {
      title: "ประเภทข้อร้องเรียน",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2564",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "2565",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    },
    {
      title: "2566",
      dataIndex: "c4",
      key: "c4",
      align: "center"
    },
    {
      title: "2567",
      dataIndex: "c5",
      key: "c5",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c6",
      key: "c6",
      align: "center"
    }
  ];

  const data7_2_16 = [
    {
      key: "1",
      c1: "วิจัย",
      c2: "0",
      c3: "0",
      c4: "0",
      c5: "0",
      c6: "0"
    },
    {
      key: "2",
      c1: "การศึกษา",
      c2: "0",
      c3: "0",
      c4: "0",
      c5: "0",
      c6: "0"
    },
    {
      key: "3",
      c1: "บริการวิชาการ",
      c2: "7",
      c3: "1",
      c4: "0",
      c5: "0",
      c6: "0"
    }
  ];

  const dataEx7_2_16 = [
    {
      c1: "วิจัย",
      c2: "0",
      c3: "0",
      c4: "0",
      c5: "0",
      c6: "0"
    },
    {
      c1: "การศึกษา",
      c2: "0",
      c3: "0",
      c4: "0",
      c5: "0",
      c6: "0"
    },
    {
      c1: "บริการวิชาการ",
      c2: "7",
      c3: "1",
      c4: "0",
      c5: "0",
      c6: "0"
    }
  ];

  const bExcelClick = xorder => {
    // console.log("Excel button clicked for order:", xorder);
    let xdata = [],
      xtabtitle = "report",
      header = [],
      header2 = [];

    if (xorder === "7_2_11") {
      xtabtitle = "7.2-11 ร้อยละการคงอยู่ของ นศ.";

      // header ชั้นบน (parent)
      header.push(
        "ปีการศึกษา",
        "ปริญญาโท",
        "",
        "",
        "ปริญญาเอก",
        "",
        "",
        "รวมรับเข้า",
        "รวมคงเหลือ"
      );

      // header ชั้นล่าง (children)
      header2.push(
        "",
        "รับเข้า",
        "ลาออก",
        "คงเหลือ",
        "รับเข้า",
        "ลาออก",
        "คงเหลือ",
        "",
        ""
      );
    } else if (xorder === "7_2_16") {
      xtabtitle = "7.2-16 จำนวนข้อร้องเรียนที่แจ้งผ่านระบบ VOC";

      header.push("ประเภทข้อร้องเรียน", "2564", "2565", "2566", "2567", "2568");
    }

    xdata.push([xtabtitle]);

    xdata.push([""]);
    xdata.push(header);

    if (header2.length > 0) {
      xdata.push(header2);
    }

    if (xorder === "7_2_11") {
      for (var row in dataEx7_2_11) {
        const xx = [];

        for (var col in dataEx7_2_11[row]) {
          xx.push(dataEx7_2_11[row][col]);
        }

        xdata.push(xx);
      }
    } else if (xorder === "7_2_16") {
      for (var row in dataEx7_2_16) {
        const xx = [];
        for (var col in dataEx7_2_16[row]) {
          xx.push(dataEx7_2_16[row][col]);
        }
        xdata.push(xx);
      }
    }

    var wb = xlsx.utils.book_new(),
      ws = xlsx.utils.json_to_sheet(xdata, { skipHeader: true });

    xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
    xlsx.writeFile(wb, xtabtitle + ".xlsx");
  };

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          ผลลัพธ์ด้านลูกค้า
        </Title>
      </div>

      {/* Row 1 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-1 ความพึงพอใจของแหล่งทุนต่อการดำเนินการวิจัยของสถาบันฯ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() => window.open("https://cmu.to/rPCMt", "_blank")}
              >
                แบบประเมิน แหล่งทุน
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-2 ความพึงพอใจตามความคาดหวังของแหล่งทุน"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() => window.open("https://cmu.to/rPCMt", "_blank")}
              >
                แบบประเมิน แหล่งทุน
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-3 ความไม่พึงพอใจของแหล่งทุนต่อการดำเนินการวิจัยของสถาบันฯ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() => window.open("https://cmu.to/rPCMt", "_blank")}
              >
                แบบประเมิน แหล่งทุน
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-4 ความพึงพอใจของนักศึกษาต่อการดำเนินการของหลักสูตร"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiYjNiMjAzMWYtNzRiNy00OGUyLTgzYmEtN2NiNDE1ODJiYTAxIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                แบบประเมิน นักศึกษา
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 3 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-5 ความไม่พึงพอใจของนักศึกษา"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiYjNiMjAzMWYtNzRiNy00OGUyLTgzYmEtN2NiNDE1ODJiYTAxIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                แบบประเมิน นักศึกษา
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-6 ความพึงพอใจของผู้ใช้บริการต่อการดำเนินงานของสถาบันฯ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Space size="large">
                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiN2NiOTBkNjItNmU5NS00MjdkLWE0MzItYjhmMTI2MDUyZjc3IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                  ghost
                >
                  GI
                </Button>

                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiMGI5ZGVkMjMtM2EwNC00OTVkLTg0ZmItYTVkOTVmOTY5NGM2IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                  ghost
                >
                  Clinic
                </Button>
              </Space>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 4 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-7 ความไม่พึงพอใจของผู้ใช้บริการต่อการดำเนินการของสถาบันฯ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Space size="large">
                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiN2NiOTBkNjItNmU5NS00MjdkLWE0MzItYjhmMTI2MDUyZjc3IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                  ghost
                >
                  GI
                </Button>

                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiMGI5ZGVkMjMtM2EwNC00OTVkLTg0ZmItYTVkOTVmOTY5NGM2IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                  ghost
                >
                  Clinic
                </Button>
              </Space>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-8 ความพึงพอใจของแหล่งทุนต่อการดำเนินการของสถาบันฯ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() => window.open("https://cmu.to/rPCMt", "_blank")}
              >
                แบบประเมิน แหล่งทุน
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 5 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-9 ความผูกพันของแหล่งทุน"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() => window.open("https://cmu.to/rPCMt", "_blank")}
              >
                แบบประเมิน แหล่งทุน
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-10 ความพึงพอใจของนักศึกษาต่อการสนับสนุนของสถาบันฯ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                color: "#9aa0a6"
              }}
            >
              <div style={{ fontSize: 28 }}>📊</div>
              <div style={{ fontSize: 16, marginTop: 8 }}>ยังไม่มีข้อมูล</div>
              <div style={{ fontSize: 12, marginTop: 4 }}>
                ไม่มีข้อมูลสำหรับแสดงในขณะนี้
              </div>
              <div style={{ fontSize: 12, marginTop: 4 }}>
                (รอข้อมูล link ไฟล์)
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 6 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-11 ร้อยละการคงอยู่ของ นศ."
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_2_11")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_2_11}
              dataSource={data7_2_11}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-12 ร้อยละของ นศ. ที่แนะนำให้ผู้อื่นมาเรียน"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_2/แบบประเมินความพึงพอใจ_ไม่พึงพอใจSHSR.docx",
                    "_blank"
                  )}
              >
                ร้อยละของ นศ. ที่แนะนำให้ผู้อื่นมาเรียน
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 7 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-13 ร้อยละของลูกค้าที่แนะนำบริการต่อให้ผู้อื่น"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Space size="large">
                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiN2NiOTBkNjItNmU5NS00MjdkLWE0MzItYjhmMTI2MDUyZjc3IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                  ghost
                >
                  GI
                </Button>

                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiMGI5ZGVkMjMtM2EwNC00OTVkLTg0ZmItYTVkOTVmOTY5NGM2IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                  ghost
                >
                  Clinic
                </Button>
              </Space>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-14 ร้อยละของลูกค้าที่จะกลับมาใช้บริการซ้ำ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Space size="large">
                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiN2NiOTBkNjItNmU5NS00MjdkLWE0MzItYjhmMTI2MDUyZjc3IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                  ghost
                >
                  GI
                </Button>

                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiMGI5ZGVkMjMtM2EwNC00OTVkLTg0ZmItYTVkOTVmOTY5NGM2IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                  ghost
                >
                  Clinic
                </Button>
              </Space>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 8 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-15 ร้อยละของลูกค้าที่พึงพอใจต่อการบริการของเจ้าหน้าที่"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Space size="large">
                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiN2NiOTBkNjItNmU5NS00MjdkLWE0MzItYjhmMTI2MDUyZjc3IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                  ghost
                >
                  GI
                </Button>

                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiMGI5ZGVkMjMtM2EwNC00OTVkLTg0ZmItYTVkOTVmOTY5NGM2IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                  ghost
                >
                  Clinic
                </Button>
              </Space>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(97, 105, 116)"
            }}
            title="7.2-16 จำนวนข้อร้องเรียนที่แจ้งผ่านระบบ VOC"
          >
            <Row style={{ float: "right", marginBottom: 8 }}>
              <Button
                ghost
                type="success"
                onClick={() => bExcelClick("7_2_16")}
              >
                <FileExcelOutlined /> Excel
              </Button>
            </Row>

            <Table
              columns={columns7_2_16}
              dataSource={data7_2_16}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard7_2;
